import React from 'react';
import { DayColumn, TimeColumn } from './Columns';
import { ROW_HEIGHT, SVG_BACKGROUND } from '../../const';
import './styles.css';
export function Calendar(_a) {
    var date = _a.date, rotations = _a.rotations, contacts = _a.contacts, timezone = _a.timezone, disabled = _a.disabled, readOnly = _a.readOnly, country = _a.country, onClick = _a.onClick, permissions = _a.permissions;
    return (React.createElement("div", { style: {
            display: 'grid',
            gridAutoFlow: 'column',
            gridTemplateRows: "40px repeat(96, ".concat(ROW_HEIGHT, "px)"),
            gridTemplateColumns: '50px repeat(7, 1fr)',
            backgroundImage: "url(\"data:image/svg+xml,".concat(encodeURIComponent(SVG_BACKGROUND), "\")"),
            backgroundColor: '#F9F9F9',
            backgroundPosition: '0px 40px',
            border: '1px solid var(--color-border-primary)',
        }, "data-testid": "tech-rotation-calendar" },
        React.createElement(TimeColumn, null),
        React.createElement(DayColumn, { date: date, rotations: rotations, contacts: contacts, timezone: timezone, disabled: disabled, readOnly: readOnly, country: country, onClick: onClick, permissions: permissions })));
}
//# sourceMappingURL=Calendar.js.map